import { render, staticRenderFns } from "./AssignLearning.vue?vue&type=template&id=5a5e1723&scoped=true"
import script from "./AssignLearning.vue?vue&type=script&lang=js"
export * from "./AssignLearning.vue?vue&type=script&lang=js"
import style0 from "./AssignLearning.vue?vue&type=style&index=0&id=5a5e1723&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e1723",
  null
  
)

export default component.exports